import React, { useState, useEffect, useContext, useRef, useCallback} from 'react';
import * as S from './styles';
import C from '@assets/themes/colors';
import { IProps } from './types';
import Tabs from '@components/Tabs';
import VehicleImages from './VehicleImages';
import OtherImages from './OtherImages';

const SearchImages: React.FC<IProps> = (props) => {
  const [options, setOptions] = useState(["VEHICLE", "BACKGROUND", "LOGO", "STOCK"]);
  const [value, setValue] = useState(props.category??"vehicle");
  
  const getTitle = () => {    
    if (props.category) {
      if (props.category==="vehicle") return `Search Vehicle Images`;
      if (props.category==="background") return `Filter Background Images`;
      else return `Search ${props.category}s`;
    } else return `Search Images`;
  }

  return (
    <>   
        <S.Root style={{
          display: props.open ? 'flex' : 'none',
        }} >
          <S.BoxContainer>
            <S.TitleContainer>
              <S.LeftSide>
                <S.Title>
                  {getTitle()}
                </S.Title>
              </S.LeftSide>
            </S.TitleContainer>
            {props.category===undefined &&
            <S.TabContent >
              <Tabs
                options={options}
                value={value}
                setValue={(value:any)=> setValue(value.toLowerCase())}
                sizes={{tabWidth: 150, barWidth: 100}}
              />
              </S.TabContent>
              }
            <S.Content id="content-container" padding={props.category===undefined?"17px 58px;":undefined}>
             
              {value==='vehicle' 
                ? <VehicleImages setOpen={props.setOpen} onSelect={(data: any) => {props.onSelect(data)}} loadingImage={props.loadingImage} showDescription={props.category!=undefined} />
                : <OtherImages setOpen={props.setOpen} onSelect={(data: any) => { props.onSelect(data)}}  loadingImage={props.loadingImage}  category={value??""} showDescription={props.category!=undefined}/>
              }
            </S.Content>
          </S.BoxContainer>
        </S.Root>      
    </>
  );
}

export default SearchImages;